import PropTypes from 'prop-types'
import React from 'react'

import BulkPrices from '../epages.base/BulkPrices'
import Buybox from '../../templateComponents/Buybox'
import BuyboxThemeComponent from '../epages.base/Buybox'
import Crossselling from '../epages.base/Crossselling'
import CustomAttributes from '../epages.base/CustomAttributes'
import EnergyLabel from '../../templateComponents/EnergyLabel'
import ImageGallery from '../epages.base/ImageGallery'
import Link from '../../templateComponents/Link'
import Percentage from '../../templateComponents/Percentage'
import PlaceholderImage from '../../PlaceholderImage'
import Price from '../../templateComponents/Price'
import ProductDescription from '../epages.base/ProductDescription'
import ProductImage from '../epages.base/ProductImage'

export default function Product({ product, shop, t }) {
  return (
    <div className="product" itemScope itemType="http://schema.org/Product">
      <section className="section">
        <div className="wrapper">
          <div className="content">
            {product.slideshow ? (
              <div className="product-image-gallery-wrapper">
                <ImageGallery product={product} />
              </div>
            ) : (
              <div className="product-image">
                {product.image ? <ProductImage image={product.image} alt={product.name} /> : <PlaceholderImage />}
              </div>
            )}

            <div className="product-info">
              <h1 className="product-info-title" itemProp="name">
                {product.name}
              </h1>
              {product.gtin && <link itemProp={`gtin${product.gtin.length}`} content={product.gtin} />}
              {(product.price || product.lowestPrice) && (
                <div className="product-info-box" itemProp="offers" itemScope itemType="http://schema.org/Offer">
                  {product.price && (
                    <>
                      <link itemProp="price" content={product.price.amount} />
                      <link itemProp="priceCurrency" content={product.price.currency} />
                    </>
                  )}
                  {product.stockLevelMicrodata && (
                    <link itemProp="availability" href={`http://schema.org/${product.stockLevelMicrodata}`} />
                  )}
                  <link itemProp="itemCondition" href={`http://schema.org/${product.conditionMicrodata}`} />
                  {product.listPrice && !product.hasVariations && (
                    <div className="product-info-box-price-old">
                      <span>{product.listPrice.formatted}</span>
                      {!product.bulkPrices && (
                        <Percentage
                          oldPrice={product.listPrice.amount}
                          newPrice={product.price.amount}
                          className="product-info-box-price-percentage"
                        />
                      )}
                    </div>
                  )}
                  {!product.listPrice && product.manufacturerPrice && !product.hasVariations && (
                    <div className="product-info-box-price-old">
                      {shop.beyond && (
                        <span className="product-info-box-price-manufacturer">
                          {t('components.productComponent.priceManufacturer')}
                        </span>
                      )}
                      <span>{product.manufacturerPrice.formatted}</span>
                      {!product.bulkPrices && (
                        <Percentage
                          oldPrice={product.manufacturerPrice.amount}
                          newPrice={product.price.amount}
                          className="product-info-box-price-percentage"
                        />
                      )}
                    </div>
                  )}
                  {!product.lowestPrice && (
                    <Price
                      className={
                        product.manufacturerPrice || product.listPrice
                          ? 'product-info-box-price-new'
                          : 'product-info-box-price-single'
                      }
                      product={product}
                    />
                  )}
                  {product.lowestPrice && (
                    <h3 className="product-info-box-price-single">
                      {t('components.productComponent.variationLowestPrice', {
                        amount: product.lowestPrice.formatted,
                      })}
                    </h3>
                  )}
                  {product.basePrice && (
                    <span className="product-info-box-price-reference">({product.basePrice.formatted})</span>
                  )}
                  <div className="product-info-box-wrapper">
                    <div className="product-info-box-vat-note">
                      {t(product.vatNote, { nsSeparator: '__' })}
                      <Link className="product-info-box-shipping-link" to={shop.legalPageUrls.shipping}>
                        {' '}
                        {t('components.productComponent.plusShipping')}
                      </Link>
                    </div>
                    {shop.beyond && product.weight && (
                      <div className="product-info-box-product-weight">
                        {t('components.productComponent.productWeight', { weight: product.weight.formatted })}
                      </div>
                    )}
                  </div>
                  <div id="ep-app-area-product-view-price"></div>
                  {product.energyLabel && (
                    <EnergyLabel
                      t={t}
                      energyLabel={product.energyLabel}
                      energyLabelSourceFile={product.energyLabelSourceFile}
                    />
                  )}
                  {product.productDataSheet && (
                    <a
                      href={product.productDataSheet}
                      target="_blank"
                      rel="noreferrer"
                      className="product-info-box-product-data-sheet"
                    >
                      {t('components.productComponent.productDataSheet')}
                    </a>
                  )}
                </div>
              )}

              <Buybox product={product}>
                <BuyboxThemeComponent t={t} product={product} isBeyondShop={Boolean(shop.beyond)} />
              </Buybox>

              <ProductDescription description={product.description} t={t} />
              <CustomAttributes customAttributes={product.customAttributes} t={t} />
              <BulkPrices product={product} t={t} />
            </div>
          </div>
          {product.hasCrossSelling && <Crossselling product={product} />}
        </div>
      </section>
    </div>
  )
}

Product.propTypes = {
  product: PropTypes.object.isRequired,
  shop: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}
